import { DeleteOutline } from '@mui/icons-material';
import { Grid, styled } from '@mui/material';

export const GridContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  padding: theme.spacing(2),
  borderRadius: 5,
}));

export const StyledDeleteIcon = styled(DeleteOutline)(({ theme }) => ({
  fontSize: '5rem',
  color: '#fff',
}));